import { ModuleFeaturePermission } from 'src/components/common'
import { MenuData } from './data'
import { MenuTitles, PermissionsCodes } from 'src/components/common/featureData'
import { useAuth } from 'src/hooks/useAuth'

interface IMenu {
  title?: string
  icon?: any
  path?: string
  badgeColor?: string
  name?: string
  sectionTitle?: string
  module?: string
  requiredRole?: string
}

const navigation = (): any => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const auth = useAuth()
  const keys = Object.keys(MenuData)
  const menu: IMenu[] = []

  keys.filter(item => {
    const value = MenuData[`${item}`]
    const permission = ModuleFeaturePermission(item, [PermissionsCodes.view, PermissionsCodes.full], value.module)
    if (permission) {
      // Check if the menu item requires a specific role
      if (value.requiredRole) {
        const hasRole = auth?.user?.roles?.some((role: any) => role.code === value.requiredRole)
        if (!hasRole) return
      }

      const menuTitleCheck = menu.find((item: any) => item?.module === value?.module)
      if (!menuTitleCheck) {
        menu.push({ sectionTitle: MenuTitles[value.module] })
      }
      if (value?.title === 'Manage Exam Category & Type') {
        menu.push({ sectionTitle: MenuTitles['assessmentOther'] })
      }
      menu.push(value)
    }
  })

  return menu
}

export default navigation
